import type { DeliveryReport } from './types';

/** Deep links from a change to where it lives: its entity in DV360, its record in Advia OS. */

const DV360_BASE = 'https://displayvideo.google.com/ng_nav';
/** Advia's DV360 partner, the same the API uses for its campaign links. */
const DEFAULT_PARTNER_ID = '1648311996';
const ADVIA_OS_RECORD_BASE = 'https://os.advia.tech/records';

export interface Dv360Target {
  advertiserId: string | null;
  insertionOrderId: string | null;
  lineItemId: string | null;
}

/** Where to find each IO's campaign, read from the report's structure. */
export interface Dv360Context {
  partnerId: string;
  advertiserId: string | null;
  campaignByIo: Map<string, string>;
}

export function dv360Context(report: DeliveryReport): Dv360Context {
  const partner = report.exe.partner as { id?: string | null } | undefined;
  const campaignByIo = new Map<string, string>();
  for (const campaign of report.structure) {
    for (const io of campaign.ios) campaignByIo.set(io.id, campaign.id);
  }
  return {
    partnerId: partner?.id ?? DEFAULT_PARTNER_ID,
    advertiserId: report.exe.advertiser.id,
    campaignByIo,
  };
}

/**
 * The most specific DV360 page the ids allow: the line item, its insertion
 * order, or the advertiser's campaigns when the campaign is not known.
 */
export function dv360Url(target: Dv360Target, context: Dv360Context): string | null {
  const advertiserId = target.advertiserId ?? context.advertiserId;
  if (!advertiserId) return null;
  const advertiserUrl = `${DV360_BASE}/p/${context.partnerId}/a/${advertiserId}`;
  const campaignId = target.insertionOrderId ? context.campaignByIo.get(target.insertionOrderId) : undefined;
  if (!campaignId || !target.insertionOrderId) return `${advertiserUrl}/campaigns`;
  const ioUrl = `${advertiserUrl}/c/${campaignId}/io/${target.insertionOrderId}`;
  return target.lineItemId ? `${ioUrl}/li/${target.lineItemId}/details` : `${ioUrl}/explorer`;
}

export function adviaOsRecordUrl(recordId: string): string {
  return `${ADVIA_OS_RECORD_BASE}/${recordId}`;
}
